import React from "react";

import { Icon } from "@iconify/react";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  Row,
  Space,
  Typography,
  Upload,
} from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { toast } from "utils/toast";

import { OrganizationConfigProps } from "js/components/Organization/types";

import { validateLink } from "../../../../utils/validators/formBuroDeCreditoCredentials";

const { Title } = Typography;

const BuroDeCredito: React.FC<OrganizationConfigProps> = ({
  data,
  onFinish,
  loading,
}) => {
  const [form] = Form.useForm();

  const checkFileIsImage = (file: any) => {
    const acceptedImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (acceptedImageTypes.includes(file.type)) {
      return true;
    } else {
      toast.error("Solo se permiten archivos de imagen (jpeg, png, jpg)");
      return false;
    }
  };

  const handleChange = (info: any) => {
    if (info.file.status === "done") {
      toast.success(`${info.file.name} archivo subido exitosamente`);
    } else if (info.file.status === "error") {
      toast.error(`${info.file.name} archivo no se pudo subir`);
    }
  };

  return (
    <>
      <div>
        <Title level={3}>Buró de Crédito</Title>
      </div>
      <div style={{ marginTop: 10 }}>
        <Paragraph>
          Asegúrate de introducir todos los campos requeridos por{" "}
          <strong>Buró de Crédito</strong>!
        </Paragraph>
      </div>
      <div style={{ marginTop: 10 }}>
        Reglas:
        <Paragraph>
          Asegúrate de introducir todos los campos requeridos por{" "}
          <strong>Buró de Crédito</strong>!
        </Paragraph>
      </div>
      <div style={{ marginTop: 30 }}>
        {data && (
          <Form
            form={form}
            onFinish={onFinish}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{
              buro_de_credito_persona_fisica_user:
                data.buro_de_credito_persona_fisica_user,
              buro_de_credito_persona_fisica_password:
                data.buro_de_credito_persona_fisica_password,
              buro_de_credito_persona_moral_user:
                data.buro_de_credito_persona_moral_user,
              buro_de_credito_persona_moral_password:
                data.buro_de_credito_persona_moral_password,
              buro_de_credito_allow_members_use_credentials:
                data.buro_de_credito_allow_members_use_credentials,
              logo: data.logo,
              terms_and_conditions_custom: data.terms_and_conditions_custom,
            }}
          >
            <Row>
              <Space size={30}>
                <Col>
                  <Form.Item
                    label={"Usuario de Persona Física"}
                    name="buro_de_credito_persona_fisica_user"
                    rules={[
                      {
                        required: true,
                        message: "El campo es requerido",
                      },
                    ]}
                  >
                    <Input data-sentry-ignore />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    label={"Contraseña de Persona Física"}
                    name="buro_de_credito_persona_fisica_password"
                    rules={[
                      {
                        required: true,
                        message: "El campo es requerido",
                      },
                    ]}
                  >
                    <Input.Password data-sentry-ignore />
                  </Form.Item>
                </Col>
              </Space>
            </Row>

            <Row>
              <Space size={30}>
                <Col>
                  <Form.Item
                    label={"Usuario de Persona Moral"}
                    name="buro_de_credito_persona_moral_user"
                    rules={[
                      {
                        required: true,
                        message: "El campo es requerido",
                      },
                    ]}
                  >
                    <Input data-sentry-ignore />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    label={"Contraseña de Persona Moral"}
                    name="buro_de_credito_persona_moral_password"
                    rules={[
                      {
                        required: true,
                        message: "El campo es requerido",
                      },
                    ]}
                  >
                    <Input.Password data-sentry-ignore />
                  </Form.Item>
                </Col>
              </Space>
            </Row>

            <Form.Item
              label={"Credenciales para Buró de Crédito"}
              name="buro_de_credito_allow_members_use_credentials"
              rules={[
                {
                  required: true,
                  message: "El campo es requerido",
                },
              ]}
            >
              <Input data-sentry-ignore />
            </Form.Item>

            <Form.Item
              label={"Términos y condiciones"}
              name="terms_and_conditions_custom"
              rules={[
                {
                  required: true,
                  message: "El campo es requerido",
                },
                {
                  validator: validateLink,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={"Logo de la Organización"}
              name="logo"
              rules={[
                {
                  required: true,
                  message: "El campo es requerido",
                },
              ]}
            >
              <Upload
                name={"logo"}
                showUploadList={false}
                beforeUpload={checkFileIsImage}
                onChange={handleChange}
              >
                <Button icon={<Icon icon="bi:upload" />}>
                  Selecciona una imagen
                </Button>
              </Upload>
            </Form.Item>

            <Image src={data.logo ?? ""} />

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                {loading ? "Guardando" : "Guardar"}
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </>
  );
};

export default BuroDeCredito;
